export default {
    baseStyle: {
        background: 'blue.900',
        color: 'white',
        '--popper-arrow-bg': '#1D295B',
    },
    defaultProps: {
        placement: 'top',
        hasArrow: true,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9vbHRpcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uL2FwZXgtb25saW5lL2NvbXBvbmVudC1saWJyYXJ5L3RoZW1lL2NvbXBvbmVudHMvdG9vbHRpcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxlQUFlO0lBQ2IsU0FBUyxFQUFFO1FBQ1QsVUFBVSxFQUFFLFVBQVU7UUFDdEIsS0FBSyxFQUFFLE9BQU87UUFDZCxtQkFBbUIsRUFBRSxTQUFTO0tBQy9CO0lBQ0QsWUFBWSxFQUFFO1FBQ1osU0FBUyxFQUFFLEtBQUs7UUFDaEIsUUFBUSxFQUFFLElBQUk7S0FDZjtDQUNGLENBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIGJhc2VTdHlsZToge1xuICAgIGJhY2tncm91bmQ6ICdibHVlLjkwMCcsXG4gICAgY29sb3I6ICd3aGl0ZScsXG4gICAgJy0tcG9wcGVyLWFycm93LWJnJzogJyMxRDI5NUInLFxuICB9LFxuICBkZWZhdWx0UHJvcHM6IHtcbiAgICBwbGFjZW1lbnQ6ICd0b3AnLFxuICAgIGhhc0Fycm93OiB0cnVlLFxuICB9LFxufVxuIl19